import Home from "./components/Home";
import Vendors from "./components/Vendors";
import Incidents from "./components/Incidents";
import Apps from "./components/Apps";
import PrivacyRequest from "./components/PrivacyRequest";
import PersonalInformationSharing from "./Reports/PersonalInformationSharing";
import UserManual from "./components/UserManual";
import ApprovalReport from "./Reports/ApprovedReport";
import SDReport from "./Reports/SummerDelete";
import DepartmentReport from "./Reports/DepartmentReport";
import DataSystems from "./components/DataSystems";
import Networks from "./components/Networks";
import GovDashboard from "./components/Dashboard/govDashboard";
import ExternalIps from "./components/ExternalIps";
import Vlans from "./components/Vlans";
import DataUsers from "./components/DataUsers";
import ManualLogin from "./components/ManualLogin";
import Dashboard from "./components/Dashboard/dashboard";
import SendPasswordLink from "./components/SendPasswordLink";
import ResetPassword from "./components/ResetPassword";
import Pias from "./components/Pias";
import TestPage from "./components/TestPage";

const AppRoutes = [
    {
        index: true,
        element: <ManualLogin />
    },
    {
        path: '/Vendor',
        element: <Vendors />
    },
    {
        path: '/Vendors',
        element: <Vendors />
    },
    {
        path: '/Incidents',
        element: <Incidents />
    },
    {
        path: '/Apps',
        element: <Apps />
    },
    {
        path: '/Apps/:id',
        element: <Apps />
    },
    {
        path: '/privacyRequest',
        element: <PrivacyRequest />
    },
    {
        path: '/PIReport/:tenantIdent',
        element: <PersonalInformationSharing />,
        name: 'PIReport'
    },
    {
        path: '/DPReport/:tenantIdent',
        element: <DepartmentReport />,
        name: 'DPReport'
    },
     {
        path: '/DPReport2/:tenantIdent',
        element: <ApprovalReport />,
        name: 'DPReport2'
    },
    {
        path: '/SDReport/',
        element: <SDReport />,
        name: 'SDReport'
    },
    {
        path: '/ApprovalReport/:tenantIdent',
        element: <ApprovalReport />,
        name: 'ApprovalReport'
    },
    {
        path: '/PIReport',
        element: <PersonalInformationSharing />
    },
    {
        path: '/UserManual',
        element: <UserManual />
    },
    {
        path: '/DataSystems',
        element: <DataSystems />
    },
    {
        path: '/Networks',
        element: <Networks />
    },
    {
        path: '/ExternalIps',
        element: <ExternalIps />
    },
    {
        path: '/govDashboard',
        element: <GovDashboard />
    },
    {
        path: '/vlans',
        element: <Vlans />
    },
    // {
    //     path: '/Datausers',
    //     element: <DataUsers />
    // },
    // {
    //     path: '/datausers/:id',
    //     element: <DataUsers />
    // },
    // {
    //     path: '/datauser',
    //     element: <DataUsers />
    // },
    {
        path: '/dashboard',
        element: <Dashboard />
    },
    {
        path: '/ManualLogin',
        element: <ManualLogin />
    },
    {
        path: '/SendPassword',
        element: <SendPasswordLink />
    },
    {
        path: 'ResetPassword',
        element: <ResetPassword />
    },
    {
        path: '/pias',
        element: <Pias />
    },
    {
        path: '/Datausers',
        element: <DataUsers />
    },
     {
        path: '/TestPage',
        element: <DataUsers />
    },
     {
        path: '/Datadeclaration',
        element: <DataUsers />
    }
];

export default AppRoutes;
